import React, { Component, PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  loadHeros,
  incrementHeroIndex,
  selectHero,
} from '../shared/store/heros';
import PageHead from '../shared/components/PageHead';
import ArtistBanner from '../shared/components/ArtistBanner';
import { SectionBlog } from './styles';
import { TFunction, useT } from '@spotify-internal/i18n-core';
import { HeaderFiller } from '../../features/Layout/HeaderFiller';

type BlogClassComponentProps = {
  loadHeros: () => void;
  incrementHeroIndex: () => void;
  location?: Location;
  hero?: {};
  t: TFunction;
};

class BlogClassComponent extends Component<
  PropsWithChildren<BlogClassComponentProps>
> {
  componentDidMount() {
    this.props.loadHeros();
  }

  render() {
    return (
      <SectionBlog data-testid="blog" data-qa="blog-page">
        <PageHead title={[this.props.t('FRODOR_278509', 'News', '')]} />
        <HeaderFiller backgroundColor="#000000" />
        <ArtistBanner
          url="/blog"
          title={this.props.t('FRODOR_278509', 'News', '')}
          hero={this.props.hero}
          search={this.props.location?.search}
        />
        {this.props.children}
      </SectionBlog>
    );
  }
}

const selector = createStructuredSelector({
  hero: selectHero,
});

const actions = { loadHeros, incrementHeroIndex };

// Props won't be added directly into the component - they'll be added via the connect() function
// The only reason we're typing them at all is to appease TS
const Blog = (props: any) => {
  const t = useT();
  return <BlogClassComponent {...props} t={t} />;
};

export default connect(selector, actions)(Blog);
